import { render, staticRenderFns } from "./mainComponent.vue?vue&type=template&id=0dd6ac17&scoped=true"
import script from "./mainComponent.vue?vue&type=script&lang=js"
export * from "./mainComponent.vue?vue&type=script&lang=js"
import style0 from "./mainComponent.vue?vue&type=style&index=0&id=0dd6ac17&prod&scoped=true&lang=css"
import style1 from "./mainComponent.vue?vue&type=style&index=1&id=0dd6ac17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6ac17",
  null
  
)

export default component.exports